import { LinkedinIcon } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface Investor {
  name: string;
  image: string;
  affiliations: string[];
  roles: string[];
  linkedin: string;
  relevance: string;
}

interface InvestorProfileProps {
  investors: Investor[];
}

export const InvestorProfile = ({ investors }: InvestorProfileProps) => {
  return (
    <Card className="border-primary/20">
    </Card>
  );
};